import React from 'react';
import PropTypes from 'prop-types';
import FilterSummary from './FilterSummary.jsx';
import { generateSearchSummary } from '../Business/RatesSearch';

const RatesFiltersSummary = ({ searchCriteria, options }) => {
    const summaries = generateSearchSummary(searchCriteria, options);

    return (
        <div id="RatesFiltersSummary" className="ui secondary segment">
            <h3>Summary of your selected filters</h3>
            { summaries.size > 0 ? <FilterSummary summaries={ summaries }/> : <label>No rate cards selected</label> }
        </div>
    );
}

RatesFiltersSummary.propTypes = {
    searchCriteria: PropTypes.object.isRequired,
    options: PropTypes.object.isRequired
};

export default RatesFiltersSummary;
